var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col gap-10"},[_vm._l((_vm.items),function(item){return [_c('CartItem',{key:item.lineId,attrs:{"item":item}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }